import { Config } from '../../../config';
import axios from 'axios';
import { ICartProps } from '../CartContext.types';
import useValidatePromoRequestMapper from './ValidatePromoRequestMapper';
import { IValidatePromoResponse } from './Promo.types';

const ValidationApiUrl = `${Config.url.PROMO_URL}/api/v1/Validation`;

const ValidatePromos = (
    cart: ICartProps,
    onSuccess: (response: IValidatePromoResponse) => void,
    onFailure: () => void
) => {
    const request = useValidatePromoRequestMapper(cart);
    // eslint-disable-next-line
    axios.post<IValidatePromoResponse>(ValidationApiUrl, request).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export default { ValidatePromos };
